<template>
  <v-list-item v-if="!large" class="search-tile">
    <v-list-item-avatar rounded size="64">
      <v-img :src="image"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ title }}</v-list-item-title>

      <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action v-if="icon">
      <v-btn icon>
        <v-icon color="grey lighten-1">{{ icon }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>

  <v-list-item v-else class="search-tile-large">
    <v-list-item-avatar rounded size="100">
      <v-img :src="image"></v-img>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="text-h5">{{ title }}</v-list-item-title>

      <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action v-if="icon">
      <v-btn @click="$emit('icon')" icon>
        <v-icon color="info">{{ icon }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<style scoped>
.search-tile {
  transition: background-color 0.25s ease-out;
}
.search-tile:hover {
  background-color: rgba(0, 0, 0, 0.07);
}
</style>

<script>
export default {
  name: "search-tile",

  props: {
    large: { type: Boolean, default: false },

    icon: { type: String, default: "" },

    title: { type: String, default: "Unavailable" },
    subtitle: { type: String, default: "Unavailable" },

    image: { type: String, default: require("../../../public/unknown.png") },
  },
};
</script>
